import axios from 'axios';

const adminApi = axios.create({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

adminApi.interceptors.request.use((req) => {
  if (typeof window !== 'undefined' && window.localStorage.getItem('adminAccessToken')) {
    req.headers.authorization = `Bearer ${JSON.parse(window.localStorage.getItem('adminAccessToken'))}`;
  }
  return req;
});

adminApi.interceptors.response.use((response) => response, (error) => {
  if (error.response.status === 401 || error.response.status === 403) {
    window.localStorage.removeItem('adminAccessToken');
    window.location.href = '/admin/login';
  }
  return Promise.reject(error);
});

export default adminApi;
